import React, { Fragment, useEffect } from "react";
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import PageNotFound from "./Components/PageNotFound/PageNotFound";
import SurveyForm from "./Pages/SurveyForm/SurveyForm";
import ToastMessage from "./Components/ToastMessage/ToastMessage";
import "./App.css";
import Gift from "./Pages/Gift/Gift";
import SurveyResponse from "./Pages/SurveyResponse/SurveyResponse";
const App = () => {
  return (
    <Fragment>
      <ToastMessage />
      <Routes>  
      <Route path="/gift/:survey_token" element={<Gift />} />
        <Route path="/" element={<PageNotFound />} />
        <Route path={`/survey/:survey_token`} element={<SurveyForm />} />
        <Route path={`/response/:survey_token`} element={<SurveyResponse />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Fragment>
  );
};

export default App;
